import { useForm } from '@framework/ui/Organisms/FinalForm';
import Question from './Question';

import { QUESTIONS_OACC, QUESTIONS_WEBINAR } from '@evercall/call-form/ui/constants';
import { mapOptionToValue } from '@framework/data-helpers/selectOptionMappers';

import CallEvent from '@evercall/domain/CallEvent';
import { CallEventType } from '@evercall/domain/vo/call/CallEventType';
import {
  TScheduleCallFormInitialValues,
  TScheduleCallFormValues,
} from '@/evercall/ui/components/ScheduleYourCall/interfaces';

import styles from './stepFields.module.scss';

const CallFormatFields = () => {
  const form = useForm<TScheduleCallFormValues, TScheduleCallFormInitialValues>();
  const { values } = form.getState();
  const isWebinar = CallEvent.isWebinar(mapOptionToValue(values?.eventTypeId) as CallEventType);

  return (
    <div className={ styles.questionFieldsWrp }>
      {
        isWebinar
          ? (
            <>
              <Question { ...QUESTIONS_WEBINAR.QA_SESSION } />
              <Question { ...QUESTIONS_WEBINAR.SEPARATED_SESSION_LINES } />
              <Question { ...QUESTIONS_WEBINAR.SPEAKER_PRESENTING_PROCESS } />
            </>
          )
          : (
            <>
              <Question { ...QUESTIONS_OACC.ATTENDEE_CHECK_IN_PROCESS } />
              <Question { ...QUESTIONS_OACC.QA_SESSION } />
              <Question { ...QUESTIONS_OACC.SEPARATED_CONFERENCE_LINES } />
              <Question { ...QUESTIONS_OACC.SPEAKER_PRESENTING_PROCESS } />
            </>
          )
      }
    </div>
  );
};

export default CallFormatFields;
